import { Alert } from 'react-bootstrap'
import TransactionReceipt from '../components/TransactionReceipt'
import { CheckCircleIconSvg } from '../../../assets/svg'

const ConfirmationStep = ({
    shieldError,
    unshieldError,
    amount,
    selectedToken,
    actionText,
    isShielding,
    shieldEstimate,
    unshieldEstimate,
    wallet
}) => {
    return (
        <>
            {/* Step Description */}
            <div
                className="card border-primary mb-3 bg-light"
                style={{
                    // backgroundColor: 'var(--bg-secondary)', 
                    border: '1px solid var(--warning-color)',
                    // color: 'var(--text-primary)'
                }}
            >
                <div className='card-body p-3'>
                    <h6 className="fw-bold mb-2 d-flex align-items-center gap-2" style={{ color: 'var(--text-primary)' }}>
                        <CheckCircleIconSvg width={20} height={20} />
                        Final Confirmation Required
                    </h6>
                    <p className="small mb-0" style={{ color: 'var(--text-secondary)' }}>
                        Please review all details carefully before confirming. This action cannot be
                        undone once submitted to the blockchain.
                    </p>
                </div>
            </div>

            {shieldError && (
                <Alert variant="danger" className="mb-3">
                    <strong>⚠️ Error:</strong> {shieldError}
                </Alert>
            )}

            {unshieldError && (
                <Alert variant="danger" className="mb-3">
                    <strong>⚠️ Error:</strong> {unshieldError}
                </Alert>
            )}

            <TransactionReceipt
                amount={amount}
                selectedToken={selectedToken}
                actionText={actionText}
                isShielding={isShielding}
                estimate={isShielding ? shieldEstimate : unshieldEstimate}
                wallet={wallet}
            />
        </>
    )
}

export default ConfirmationStep
